// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "passengersForm-1kx66";
var _5 = "submit-89kNR";
var _6 = "passenger-20Eqh";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "passengersForm", _5 as "submit", _6 as "passenger" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "passengersForm": _4, "submit": _5, "passenger": _6 }
